import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export enum ReviewMessageType {
  startedEditing = 'started-editing',
  stoppedEditing = 'stopped-editing',
  updateStyle = 'update-style',
  updateContent = 'update-content',
  updateSrc = 'update-src',
  updateHref = 'update-href',
  deleteElement = 'delete-element',
  hideOverlay = 'hide-overlay'
}

export enum PostMessageType {
  startedEditing = 'started-editing',
  stoppedEditing = 'stopped-editing',
  selectedElement = 'selected-element',
  iframeError = 'iframe-error',
  updateContent = 'update-content'
}

// Helper function to convert CSS string to object
export const cssStringToObject = (cssString: string): Record<string, string> => {
  const styleObject: Record<string, string> = {};
  const cssRules = cssString.split(';').filter(rule => rule.trim());

  cssRules.forEach(rule => {
    const [property, value] = rule.split(':').map(part => part.trim());
    if (property && value) {
      // Convert kebab-case to camelCase
      const camelProperty = property.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
      styleObject[camelProperty] = value;
    }
  });

  return styleObject;
};
